import RegistrationGuidelines from "../components/Guidelines/RegisterationGuidelines";

export default function Registration() {
    return(
        <main className=" mt-28">

            <RegistrationGuidelines />
        </main>
    )
}